/**
 * Default map-center fallbacks (Moscow center) used when nothing is selected.
 *
 * These are two historically-divergent values for the same concept; kept
 * separate to preserve exact behavior. Candidate to unify later.
 */
export const DEFAULT_MAP_CENTER = [55.76, 37.62]; // address forms / profile / order-edit
export const PICKUP_MAP_CENTER = [55.752, 37.6175]; // pickup & landing map fallback
